/* Fräsus Maximus – Interaktion für Lieferumfang, Absaugung, Oberfräsen-Check und FAQ (ohne Abhängigkeiten) */
(function () {
  'use strict';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Lieferumfang ---------- */
  function initLu(root) {
    var items = $$(root, '[data-lu-item]');
    var rows = $$(root, '[data-lu-row]');
    var hots = $$(root, '[data-lu-hot]');
    var dots = $$(root, '[data-lu-dot]');
    var n = items.length, cur = 0, seen = items.map(function (_, i) { return i === 0; });
    function show(i) {
      cur = (i + n) % n;
      seen[cur] = true;
      items.forEach(function (el, k) { el.hidden = k !== cur; });
      rows.forEach(function (el) { var k = +el.getAttribute('data-i'); el.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); el.classList.toggle('fm-seen', !!seen[k]); });
      hots.forEach(function (el) { var k = +el.getAttribute('data-i'); el.classList.toggle('fm-on', k === cur); el.classList.toggle('fm-seen', !!seen[k]); });
      dots.forEach(function (el, k) { el.classList.toggle('fm-on', k === cur); el.classList.toggle('fm-seen', !!seen[k] && k !== cur); });
    }
    rows.concat(hots).forEach(function (el) { el.addEventListener('click', function () { show(+el.getAttribute('data-i')); }); });
    var prev = $(root, '[data-lu-prev]'), next = $(root, '[data-lu-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    if (n) show(0);
  }

  /* ---------- Absaugung: Foto-Regler / Video ---------- */
  function initAb(root) {
    var ba = $(root, '[data-ab-stage]');
    var range = $(root, '[data-ab-range]');
    var vidWrap = $(root, '[data-ab-vid]');
    var video = vidWrap ? $(vidWrap, 'video') : null;
    var prog = $(root, '[data-ab-prog]');
    var btns = $$(root, '[data-ab-mode]');
    var texts = $$(root, '[data-ab-text]');
    var raf = 0;
    var vst = video ? (+video.getAttribute('data-start') || 0) : 0;
    var vln = video ? (+video.getAttribute('data-len') || 0) : 0;
    function vend() { return video && video.duration ? (vln ? Math.min(video.duration, vst + vln) : video.duration) : 0; }
    function setCut(v) { ba.style.setProperty('--fm-cut', v + '%'); ba.style.setProperty('--fm-cutr', (100 - v) + '%'); }
    if (range) { range.addEventListener('input', function () { setCut(+range.value); }); setCut(+range.value || 50); }
    function tick() {
      if (!video || video.paused) { raf = 0; return; }
      var end = vend();
      if (end && (video.currentTime >= end - 0.06 || video.currentTime < vst - 0.5)) { try { video.currentTime = vst; } catch (e) {} }
      if (prog && end > vst) prog.style.width = Math.max(0, Math.min(100, (video.currentTime - vst) / (end - vst) * 100)).toFixed(1) + '%';
      raf = requestAnimationFrame(tick);
    }
    function mode(m) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ab-mode') === m ? 'true' : 'false'); });
      texts.forEach(function (t) { t.hidden = t.getAttribute('data-ab-text') !== m; });
      if (vidWrap) vidWrap.classList.toggle('fm-on', m === 'video');
      if (!video) return;
      if (m === 'video') {
        video.muted = true;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
        if (!raf) raf = requestAnimationFrame(tick);
      } else {
        video.pause();
        try { video.currentTime = vst; } catch (e) {}
        if (prog) prog.style.width = '0%';
      }
    }
    if (video) video.addEventListener('play', function () { if (!raf) raf = requestAnimationFrame(tick); });
    btns.forEach(function (b) { b.addEventListener('click', function () { mode(b.getAttribute('data-ab-mode')); }); });
  }

  /* ---------- Oberfräsen-Check: Suche, Hersteller, aufklappbare Liste ---------- */
  function initOc(root) {
    var input = $(root, '[data-oc-q]');
    var brands = $$(root, '[data-oc-brand]');
    var models = $$(root, '[data-oc-model]');
    var list = $(root, '[data-oc-list]');
    var count = $(root, '[data-oc-count]');
    var more = $(root, '[data-oc-more]');
    var nohit = $(root, '[data-oc-nohit]');
    var total = models.length, brand = 'Alle', all = false;
    var norm = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); };
    // Treffer nur am Wortanfang („OF 1400“ findet nicht „POF 1400 ACE“, „1400“ findet beide)
    var hit = function (key, q) {
      var words = String(key || '').toLowerCase().split(/\s+/).filter(Boolean), compact = words.join(''), starts = [], p = 0;
      words.forEach(function (w) { starts.push(p); p += w.length; });
      for (var i = compact.indexOf(q); i >= 0; i = compact.indexOf(q, i + 1)) if (starts.indexOf(i) >= 0) return true;
      return false;
    };
    function apply() {
      var q = norm(input ? input.value : '');
      var shown = 0;
      models.forEach(function (m) {
        var ok = (brand === 'Alle' || m.getAttribute('data-brand') === brand) && (!q || hit(m.getAttribute('data-key'), q));
        m.hidden = !ok;
        if (ok) shown++;
      });
      var filtered = !!q || brand !== 'Alle';
      var clamp = !filtered && !all;
      if (list) list.classList.toggle('fm-clamp', clamp);
      if (more) more.hidden = !(clamp && total > 12);
      if (nohit) nohit.hidden = shown !== 0;
      if (count) {
        count.textContent = shown === 0 ? (count.getAttribute('data-none') || 'Kein Treffer in der Liste.')
          : filtered ? shown + ' von ' + total + ' bereits erprobten Modellen'
          : (count.getAttribute('data-all') || (total + ' Modelle sind bei meinen Kunden bereits im Einsatz'));
      }
    }
    brands.forEach(function (b) {
      b.addEventListener('click', function () {
        brand = b.getAttribute('data-oc-brand');
        brands.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    if (input) input.addEventListener('input', apply);
    if (more) more.addEventListener('click', function () { all = true; apply(); });
    apply();
  }

  /* ---------- FAQ: Themen und Akkordeon ---------- */
  function initFaq(root) {
    var cats = $$(root, '[data-faq-cat]');
    var qas = $$(root, '[data-faq-item]');
    function openOnly(el) {
      qas.forEach(function (q) {
        var on = q === el;
        q.classList.toggle('fm-open', on);
        var b = $(q, 'button'), a = $(q, '[data-faq-a]');
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (a) a.hidden = !on;
      });
    }
    qas.forEach(function (q) {
      var b = $(q, 'button');
      if (b) b.addEventListener('click', function () { openOnly(q.classList.contains('fm-open') ? null : q); });
    });
    cats.forEach(function (c) {
      c.addEventListener('click', function () {
        var k = c.getAttribute('data-faq-cat');
        cats.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        var first = null;
        qas.forEach(function (q) {
          var ok = k === 'alle' || q.getAttribute('data-cat') === k;
          q.hidden = !ok;
          if (ok && !first) first = q;
        });
        openOnly(first);
      });
    });
  }

  var INIT = { '[data-fm-lu]': initLu, '[data-fm-ab]': initAb, '[data-fm-oc]': initOc, '[data-fm-faq]': initFaq };
  function initAll(scope) {
    Object.keys(INIT).forEach(function (sel) {
      $$(scope || document, sel).forEach(function (root) {
        if (root.__fm) return;
        root.__fm = true;
        try { INIT[sel](root); } catch (e) { console.error('fm-sections', sel, e); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();